
import { TicketService } from "@/services/ticket-service";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			TicketService
		};
	},
	computed: {
		nextDisabled():boolean{
			return !TicketService.hasNext();
		},
		previousDisabled():boolean{
			return !TicketService.hasPrevious();
		}
	},
	methods: {
		async next(){
			let id = await TicketService.nextId();
			if (id == 0) return;
			this.$router.push(`/ticket/${id}`);
		},
		async previous(){
			let id = await TicketService.previousId();
			if (id == 0) return;
			this.$router.push(`/ticket/${id}`);
		}
	}
});
